import { createReducer, on } from '@ngrx/store';
import { applyCarLoanFailure, applyCarLoanSuccess, applyCreditCardLoanFailure, applyCreditCardLoanSuccess, applyHomeLoanFailure, applyHomeLoanSuccess, applyLoanFailure, applyLoanSuccess, getActiveLoansFailure, getActiveLoansSuccess, getAvailableLoansFailure, getAvailableLoansSuccess, getLoanPurposesFailure, getLoanPurposesSuccess, repayLoanFailure, repayLoanSuccess, topUpLoanFailure, topUpLoanSuccess } from './actions';

export const AVAILABLE_LOANS_FEATURE_KEY = 'availableLoans';
export const ACTIVE_LOANS_FEATURE_KEY = 'activeLoans';
export const LOAN_PURPOSES_FEATURE_KEY = 'loanPurposes';

/**
 * Get available loans
 */
export interface GetAvailableLoansState {
  error: any;
  availableLoans: any[];
}

export const initialGetAvailableLoansState: GetAvailableLoansState = {
  error: null,
  availableLoans: [],
};

export const getAvailableLoansReducer = createReducer(
  initialGetAvailableLoansState,
  on(getAvailableLoansSuccess, (state: any, action: any) => {
    return {
      ...state,
      availableLoans: [...state.availableLoans, { ...action.availableLoans }],
    };
  }),
  on(getAvailableLoansFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);

/**
 * Get active loans
 */
export interface GetActiveLoansState {
  error: any;
  activeLoans: any[];
}

export const initialGetActiveLoansState: GetActiveLoansState = {
  error: null,
  activeLoans: [],
};

export const getActiveLoansReducer = createReducer(
  initialGetActiveLoansState,
  on(getActiveLoansSuccess, (state: any, action: any) => {
    return {
      ...state,
      activeLoans: [...state.activeLoans, { ...action.activeLoans }],
    };
  }),
  on(getActiveLoansFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);

/**
 * Apply for a loan
*/

export interface ApplyLoanState {
  error: any;
  loanDetails: any[];
}

export const initialApplyLoanState: ApplyLoanState = {
  error: null,
  loanDetails: [],
};

export const applyLoanReducer = createReducer(
  initialApplyLoanState,
  on(applyLoanSuccess, (state: any, action: any) => {
    return {
      ...state,
      loanDetails: [...state.loanDetails, { ...action.loanDetails }],
    };
  }),
  on(applyLoanFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);













export interface ApplyCarLoanState {
  error: any;
  loanDetails: any[];
}

export const initialApplyCarLoanState: ApplyCarLoanState = {
  error: null,
  loanDetails: [],
};

export const applyCarLoanReducer = createReducer(
  initialApplyCarLoanState,
  on(applyCarLoanSuccess, (state: any, action: any) => {
    return {
      ...state,
      loanDetails: [...state.loanDetails, { ...action.loanDetails }],
    };
  }),
  on(applyCarLoanFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);


export interface ApplyHomeLoanState {
  error: any;
  loanDetails: any[];
}

export const initialApplyHomeLoanState: ApplyHomeLoanState = {
  error: null,
  loanDetails: [],
};

export const applyHomeLoanReducer = createReducer(
  initialApplyHomeLoanState,
  on(applyHomeLoanSuccess, (state: any, action: any) => {
    return {
      ...state,
      loanDetails: [...state.loanDetails, { ...action.loanDetails }],
    };
  }),
  on(applyHomeLoanFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);





/**
 * Loan top up
*/

export interface TopUpLoanState {
  error: any;
  loanDetails: any[];
}

export const initialTopUpLoanState: TopUpLoanState = {
  error: null,
  loanDetails: [],
};

export const topUpLoanReducer = createReducer(
  initialTopUpLoanState,
  on(topUpLoanSuccess, (state: any, action: any) => {
    return {
      ...state,
      loanDetails: [...state.loanDetails, { ...action.loanDetails }],
    };
  }),
  on(topUpLoanFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);

/**
 * Repay loan
 */

export interface RepayLoanState {
  error: any;
  loanDetails: any[];
}

export const initialRepayLoanState: RepayLoanState = {
  error: null,
  loanDetails: [],
};

export const repayLoanReducer = createReducer(
  initialRepayLoanState,
  on(repayLoanSuccess, (state: any, action: any) => {
    return {
      ...state,
      loanDetails: [...state.loanDetails, { ...action.loanDetails }],
    };
  }),
  on(repayLoanFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);

/**
 * Loan purposes
 */
export interface LoanPurposesState {
  error: any;
  homeLoanPurposes: any[];
  carLoanPurposes: any[];
  creditCardPurposes: any[];
}

export const initialLoanPurposesState: LoanPurposesState = {
  error: null,
  homeLoanPurposes: [],
  carLoanPurposes: [],
  creditCardPurposes: [],
};

export const loanPurposesReducer = createReducer(
  initialLoanPurposesState,
  on(getLoanPurposesSuccess, (state, action) => {
    if (action.loanType === 'home') {
      return {
        ...state,
        error: null,
        homeLoanPurposes: action.purposes || [],
      };
    }

    if (action.loanType === 'credit-card') {
      return {
        ...state,
        error: null,
        creditCardPurposes: action.purposes || [],
      };
    }

    return {
      ...state,
      error: null,
      carLoanPurposes: action.purposes || [],
    };
  }),
  on(getLoanPurposesFailure, (state, action) => ({
    ...state,
    error: action.error,
  }))
);

export interface ApplyCreditCardLoanState {
  error: any;
  loanDetails: any[];
}

export const initialApplyCreditCardLoanState: ApplyCreditCardLoanState = {
  error: null,
  loanDetails: [],
};

export const applyCreditCardLoanReducer = createReducer(
  initialApplyCreditCardLoanState,
  on(applyCreditCardLoanSuccess, (state: any, action: any) => ({
    ...state,
    loanDetails: [...state.loanDetails, { ...action.loanDetails }],
  })),
  on(applyCreditCardLoanFailure, (state, action) => ({
    ...state,
    error: action.error,
  }))
);
